import { ChangeDetectionStrategy, Component, Inject, Input, OnDestroy } from '@angular/core';
import { PolicyDetailsService } from '@app/my-zone/services/policy-details.service';
import { DownloadingModalComponent } from '@app/shared/modals/downloading/downloading-modal.component';
import {
    NewModal,
    PolicyProductIdEnum,
    PolicyValidityStatusCodeEnum,
    PurchasedProductInterface,
    RelationInterface,
} from 'outshared-lib';
import { WINDOW } from '@inshared/shared/util';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { WucDisplayFieldModule, WucLinkModule, WucRackModule } from '@inshared/website-ui-components';
import { DocumentsEnum } from '@inshared/shared/core';

@Component({
    selector: 'ins-insurance-terms-and-conditions',
    templateUrl: './insurance-terms-and-conditions.component.html',
    standalone: true,
    imports: [
        CommonModule,
        WucLinkModule,
        WucDisplayFieldModule,
        WucRackModule,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsuranceTermsAndConditionsComponent implements OnDestroy {
    @Input() public purchasedProduct!: PurchasedProductInterface;
    @Input() public relation!: RelationInterface;
    public productIdEnum = PolicyProductIdEnum;
    public validityStatusCodeEnum = PolicyValidityStatusCodeEnum;
    public downloadUrl = '/documenten/download/voorwaarden-';
    public documentsEnum = DocumentsEnum;

    private subscriptions = new Subscription();

    constructor(
        private policyDetailsService: PolicyDetailsService,
        private newModal: NewModal,
        @Inject(WINDOW) private window: Window,
    ) {
    }

    public ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    public getPolicy(): boolean {
        const modalRef = this.newModal.open(DownloadingModalComponent);
        const historyIndication = 'J';
        const policyDownload = this.policyDetailsService
            .downloadPolicy(historyIndication)
            .pipe(map((result) => result.data))
            .subscribe((res) => {
                modalRef.close();
                this.window.location.href = `/documenten/download/${res.pdf}`;
            });
        this.subscriptions.add(policyDownload);
        return false;
    }
}
